"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStaticPrefix = getStaticPrefix;
exports.getStaticUrl = getStaticUrl;

function getStaticPrefix(benderPackage) {
  var injectedBenderDeps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  // Accessing window.hubspot.bender directly is necessary so that
  // we don't end up with a blocking module in apps that don't incorporate
  // the mixin
  var benderDeps = injectedBenderDeps || window.hubspot && window.hubspot.bender;
  var staticDomainPrefix = benderDeps.staticDomainPrefix,
      depVersions = benderDeps.depVersions,
      depPathPrefixes = benderDeps.depPathPrefixes;

  if (!staticDomainPrefix || !depVersions || !depPathPrefixes) {
    return '';
  }

  var prefix = staticDomainPrefix; // So that the URL can be requested when the app are run locally via asset-bender,
  // we override the domain to use the CDN instead of the local domain

  if (staticDomainPrefix === '//local.hsappstatic.net') {
    if (depVersions[benderPackage] !== 'static') {
      prefix = '//static.hsappstatic.net';
    }
  }

  if (!depPathPrefixes[benderPackage]) {
    // eslint-disable-next-line no-console
    console.error('Bender package %s is missing from static_conf.json', benderPackage);
    return '';
  }

  return "" + prefix + depPathPrefixes[benderPackage];
}

function getStaticUrl(benderPackage, path) {
  var injectedBenderDeps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return "" + getStaticPrefix(benderPackage, injectedBenderDeps) + path;
}